import {
  apiClient,
  APIResponse,
  extractApiError,
} from './api';

export const accountAPI = {
  async changePassword({ old_password, new_password1, new_password2 }) {
    try {
      await apiClient.post('/auth/password/change/', {
        old_password,
        new_password1,
        new_password2,
      });
      return APIResponse.success(null);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível alterar a password.'));
    }
  },

  async requestEmailChange({ new_email, current_password }) {
    try {
      const { data } = await apiClient.post('/account/email-change/request/', {
        new_email,
        current_password,
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível pedir a alteração de email.'));
    }
  },

  async confirmEmailChange({ token }) {
    try {
      const { data } = await apiClient.post('/account/email-change/confirm/', { token });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível confirmar o novo email.'));
    }
  },

  async deleteAccount({ confirmation, current_password }) {
    try {
      await apiClient.post('/account/delete/', {
        confirmation,
        current_password,
      });
      return APIResponse.success(null);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível apagar a conta.'));
    }
  },
};
